// easeOutQuart 等の easing は WordPress 同梱の jquery-effects-core が提供する
// （functions.php の enqueue で依存に指定）。旧: require('jquery.easing')

export default {
  init() {
    // JavaScript to be fired on all pages
    const $win = $(window);
    const $body = $('body');

    // ブラウザ判定
    // ------------------------
    var ua = window.navigator.userAgent.toLowerCase();
    if(ua.match(/msie/i) || ua.match(/rident/i)) {
      var ieVersion = parseInt(ua.match(/((msie|MSIE)\s|rv:)([\d.]+)/)[3]);
      $body.addClass(`ie ie${ieVersion}`);
    }
    else if(ua.match(/edge/i)) {
      $body.addClass('edge');
    }

    // ブラウザのUIを考慮したビューポートの高さをcssに受け渡す
    const setVH = () => {
      document.documentElement.style.setProperty('--vh', `${window.innerHeight}px`);
    };
    $(window).resize(setVH);
    setVH();

    // スクロールしたらヘッダーを縮小
    // ------------------------
    const $header = $('header.global_header');
    $win.on('load scroll', ()=> {
      if ( 20 < $win.scrollTop() ) {
        $header.addClass('shrinked');
      } else {
        $header.removeClass('shrinked');
      }
    });

    // ページ内リンクのスクロール関係
    // ------------------------
    var scrollTo = function(_target, _speed, _callback){
      var target = _target instanceof jQuery ? _target : $(_target);
      var position;
      if(target.prop('tagName') == 'BODY'){
        position = 0;
      }
      else{
        position = target.position().top;
      }
      $('html,body').stop().animate({scrollTop: position}, _speed || 1000, 'easeOutQuart', _callback);
    };
    $body
      .on('click', 'a[href*="#"]', function(e){
        // 現在開いているページのページ内リンクだったら…
        var _link = $(this).attr('href').split('#');
        if(_link[0]=== '' || _link[0] === location.pathname){
          e.preventDefault();
          scrollTo('#'+_link[1]);
        }
      })
      // メニューの表示非表示
      .on('click', '#gnav_btn', function(){
        $body.toggleClass('gnav_opened');
      })
      .on('click', '#gnav_content', function(e){
        var t = $(e.target);
        if(t.is('#gnav_content') || t.is('#gnav_close')){
          $body.removeClass('gnav_opened');
        }
      })
      // SCROLLボタン
      .on('click', '.scroll', ()=> {
        $('html,body').stop().animate({scrollTop: $win.scrollTop()+$win.height()/2}, 1000, 'easeOutQuart');
      });

    $win.on('load', function() {
      if(location.hash){
        scrollTo(location.hash);
      }
    });

    // 他の授業を見るボタン
    $body.on('click', '#loadmore>a:not([disabled])', (e) => {
      e.preventDefault();
      $(this).attr('disabled','disabled');
      let btn_current_page = $('#loadmore>a');
      $.ajax({
        url: btn_current_page.attr('href'),
        type: 'GET',
        dataType: 'html'
      })
        .done((data) => {
          $('section.report .reports').append($(data).filter('main').find('section.report .reports').html());
          const btn_in_next_page = $(data).filter('main').find('#loadmore>a');
          if(btn_in_next_page.length) {
            btn_current_page.removeAttr('disabled').attr('href', btn_in_next_page.attr('href'));
          }
          else {
            btn_current_page.remove();
          }
        })
        .fail((data) => { console.error(data); });
    });
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  }
};
